import { render, staticRenderFns } from "./APeriodSelector.vue?vue&type=template&id=67cb98a2&scoped=true&"
import script from "./APeriodSelector.vue?vue&type=script&lang=js&"
export * from "./APeriodSelector.vue?vue&type=script&lang=js&"
import style0 from "./APeriodSelector.vue?vue&type=style&index=0&id=67cb98a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cb98a2",
  null
  
)

export default component.exports